import React, { useLayoutEffect } from 'react';
import CentumSeatlistMobile from './designcomponents/centumseatlistmobile';

// 디자인(리마인드 Mobile 사본.html)은 모바일 전용이라 분기 없이 모바일 컴포넌트 1종만 렌더한다.
// 넓은 화면에서는 컴포넌트 내부에서 max-width:500px 로 가운데 정렬된다.
export default function CentumSeatlist() {
  useLayoutEffect(() => { window.scrollTo(0, 0); }, []);
  return <CentumSeatlistMobile />;
}
